exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.invalid-feedback {\n    color: red;\n}\n.btn-input-block {\n    height: 35px;\n    width: 35px;\n}\n", ""]);

// exports
